import type { AppState, AppStateAction } from './types';

import { CustomFlowType } from '@repo/common';

import { AppStateActionType } from './constants';
import { selectStep } from './selectors';

import { resolveStep } from '@/utils/workflow';

export const initialAppState: AppState = {
  workflow: null,
  steps: [],
  alternateStep: null,
  infoModal: null,
  customerData: null,
  submitErrorContext: null,
  viewType: null,
  verificationOnMobile: false,
  customFlowType: CustomFlowType.Idv,
  stepData: {},
};

export function appReducer(state: AppState, action: AppStateAction): AppState {
  switch (action.type) {
    case AppStateActionType.SET_WORKFLOW: {
      const workflow = action.value;
      const currentStep = selectStep(state);
      const step = workflow?.nextStep ? resolveStep(currentStep, workflow.nextStep) : null;

      return {
        ...state,
        workflow,
        steps: step ? [step] : [],
        alternateStep: null,
      };
    }

    case AppStateActionType.SET_STEP: {
      const currentStep = selectStep(state);
      const step = action.value ? resolveStep(currentStep, action.value) : null;

      if (!step) {
        return state;
      }

      return { ...state, steps: [...state.steps, step] };
    }

    case AppStateActionType.SET_ALTERNATE_STEP: {
      return { ...state, alternateStep: action.value };
    }

    case AppStateActionType.SET_PREV_STEP: {
      if (state.steps.length < 2) {
        return state;
      }

      const steps = state.steps.slice(0, -1);

      return { ...state, steps };
    }

    case AppStateActionType.SET_FIRST_STEP:
      if (state.steps.length < 2) {
        return state;
      }

      return { ...state, steps: state.steps.slice(0, 1) };

    case AppStateActionType.TOGGLE_INFO_MODAL: {
      return { ...state, infoModal: action.value };
    }

    case AppStateActionType.SET_CUSTOMER_DATA: {
      return { ...state, customerData: action.value };
    }

    case AppStateActionType.SET_VIEW_TYPE: {
      return { ...state, viewType: action.value };
    }

    case AppStateActionType.SET_VERIFICATION_ON_MOBILE: {
      return { ...state, verificationOnMobile: action.value };
    }

    case AppStateActionType.SET_CUSTOM_FLOW_TYPE: {
      return { ...state, customFlowType: action.value };
    }

    case AppStateActionType.SET_STEP_DATA: {
      return { ...state, stepData: { ...state.stepData, [action.stepKey]: action.value } };
    }

    case AppStateActionType.SET_SUBMIT_ERROR_CONTEXT: {
      return { ...state, submitErrorContext: action.value };
    }

    default: {
      throw Error('Unknown action: ', action);
    }
  }
}
